<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="创建人">
              <a-input
                v-model="queryParam.createName"
                placeholder="请输入"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="审核状态">
              <a-select v-model="queryParam.status" placeholder="请选择状态">
                <a-select-option value="1">待审核</a-select-option>
                <a-select-option value="2">审核中</a-select-option>
                <a-select-option value="3">审核通过</a-select-option>
                <a-select-option value="4">审核拒绝</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="素材类型">
              <a-select v-model="queryParam.type" placeholder="请选择分类">
                <a-select-option value="1">话术素材</a-select-option>
                <a-select-option value="2">欢迎语素材</a-select-option>
                <a-select-option value="3">群发素材</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery('dic')" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
        <a-row v-if="show" :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="视图">
              <a-select v-model="queryParam.view" placeholder="请选择分类">
                <a-select-option value="1">全部的</a-select-option>
                <a-select-option value="2">我创建的</a-select-option>
                <a-select-option value="3">待我审核</a-select-option>
                <a-select-option value="4">我审核过的</a-select-option>
                <a-select-option value="5">他人审核</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        bordered
        size="middle"
        :columns="columns"
        @change="handleTableChange"
        :pagination="ipagination"
        :dataSource="dataSource"
        :loading="loading"
        :rowKey="r => r.id"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="showmodal(record)">查看</a>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->
    <examine-modal
      ref="examodal"
      :visible="visible"
      :modaldata="modaldata"
      @cancle="cancle"
      @ok="modalOk"
    ></examine-modal>
  </a-card>
</template>

<script>
import examineModal from './examineModal';
import { getExamineDetail, getExamineList, changeExamine } from '@/api/api';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';

export default {
  name: 'examineList',
  mixins: [JeecgListMixin],
  components: {
    examineModal
  },

  data() {
    return {
      columns: [
        {
          title: '素材类型',
          align: 'center',
          dataIndex: 'materialName'
        },
        {
          title: '分类',
          align: 'center',
          dataIndex: 'categoryName'
        },
        {
          title: '创建人',
          align: 'center',
          dataIndex: 'createName',
          customRender: function(text, record, index) {
            if (!text) {
              return '--';
            }
            let list = JSON.parse(sessionStorage.getItem('CREATEPOPLIST'));
            let textTemp = text.toLocaleLowerCase();
            let target = list.find(
              item => item.userName.toLocaleLowerCase() == textTemp
            );
            if (target) {
              return target.realName;
            } else {
              return text;
            }
          }
        },
        {
          title: '发起审核时间',
          align: 'center',
          dataIndex: 'examineTime'
        },
        {
          title: '审核状态',
          align: 'center',
          dataIndex: 'status',
          customRender: function(text, record, index) {
            if (text == 1) {
              return '待审核';
            } else if (text == 2) {
              return '审核中';
            } else if (text == 3) {
              return '审核通过';
            } else if (text == 4) {
              return '审核拒绝';
            } else {
              return text;
            }
          }
        },
        {
          title: '审核通过时间',
          align: 'center',
          dataIndex: 'examineSuccessTime',
          customRender: function(text, record, index) {
            if (!text) {
              return '--';
            } else {
              return text;
            }
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action'
          },
          align: 'center'
        }
      ],
      loading: false,
      visible: false,
      url: {
        list: 'wechatwork-examine-biz/wechatwork/examine/getExamineList'
      },
      show: false,
      modaldata: {},
      flg: null
    };
  },
  computed: {},
  methods: {
    modalOk() {
      this.visible = false;
      this.loadData(1);
    },
    cancle() {
      this.visible = false;
    },
    showmodal(record) {
      this.visible = true;
      this.$refs.examodal.getdata(record);
    },
    // searchQuery(){//搜索查询
    // debugger
    //   let params = {
    //     createName:handleName(this.queryParam.createName),
    //     status:this.queryParam.key,
    //     type:this.queryParam.typeId,
    //     pageNo: 1,
    //     pageSize: 10
    //   }
    //   this.getDataInfo(params);
    // },
    getDataInfo(data) {
      getExamineList(data || {}).then(res => {
        if (res.success) {
          this.dataSource = res.result.list;
        }
      });
    }
  },
  mounted() {}
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
